// TODO: Uncomment when backend endpoint is deployed and OpenAPI types regenerated
// import { apiInstance } from '../service-trips-api/service-trips-api';
import {
  MarkNotificationsReadRequest,
  NotificationListResponse,
  NotificationSearchRequest,
  NotificationSummaryResponse,
} from '../service-trips-api/types/notification';
import { NotificationService } from './notification-service.interface';

/**
 * Real backend implementation of NotificationService.
 *
 * REST endpoints (verified pattern from CabonlineTeam/service-trips):
 *   GET  /v1/notifications/summary  → NotificationSummaryResponse
 *   POST /v1/notifications/search   → NotificationListResponse
 *   PUT  /v1/notifications/read     → 204
 *   PUT  /v1/notifications/read-all → 204
 *
 * Push channel:
 *   v1: Polling only (React Query refetchInterval: 30s). No WebSocket/SSE in backend.
 *   v2: Add SSE or WebSocket when backend infrastructure is available.
 */
export class NotificationApiService implements NotificationService {
  private listeners: Array<() => void> = [];
  private pushRefCount = 0;

  async getSummary(): Promise<NotificationSummaryResponse> {
    // TODO: Uncomment when backend endpoint is deployed and OpenAPI types regenerated
    // return apiInstance.request('/v1/notifications/summary', { method: 'get' });
    throw new Error('NotificationApiService.getSummary not implemented — backend endpoint not available yet');
  }

  async getNotifications(
    request: NotificationSearchRequest
  ): Promise<NotificationListResponse> {
    // TODO: Uncomment when backend endpoint is deployed and OpenAPI types regenerated
    // return apiInstance.request('/v1/notifications/search', { method: 'post', body: request });
    throw new Error('NotificationApiService.getNotifications not implemented — backend endpoint not available yet');
  }

  async markAsRead(request: MarkNotificationsReadRequest): Promise<void> {
    // TODO: Uncomment when backend endpoint is deployed and OpenAPI types regenerated
    // await apiInstance.request('/v1/notifications/read', { method: 'put', body: request });
    throw new Error('NotificationApiService.markAsRead not implemented — backend endpoint not available yet');
  }

  async markAllAsRead(): Promise<void> {
    // TODO: Uncomment when backend endpoint is deployed and OpenAPI types regenerated
    // await apiInstance.request('/v1/notifications/read-all', { method: 'put' });
    throw new Error('NotificationApiService.markAllAsRead not implemented — backend endpoint not available yet');
  }

  onUpdate(listener: () => void): () => void {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((fn) => fn !== listener);
    };
  }

  startPush(): void {
    // v1: No-op — polling via React Query refetchInterval handles freshness.
    // v2: Add SSE/WebSocket connection here when backend infrastructure is available.
    this.pushRefCount += 1;
  }

  stopPush(): void {
    this.pushRefCount = Math.max(0, this.pushRefCount - 1);
  }
}
